{
  "enum": {
    "IxcGenerateV1MonthlyStatementsJobStatus": {
      "CREATING": "Creating",
      "DONE": "Done",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcGenerateV1MonthlyStatementsTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcGenerateV1PreviewMonthlyStatementFileFormat": {
      "HTML": "HTML",
      "PDF": "PDF",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcGenerateV1PreviewTradeConfirmationFileFormat": {
      "HTML": "HTML",
      "PDF": "PDF",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcGenerateV1TradeConfirmationsJobStatus": {
      "CREATING": "Creating",
      "DONE": "Done",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcGenerateV1TradeConfirmationsTaskStatus": {
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListFilterableFields": {
      "jobId": "Job",
      "status": "Status"
    },
    "IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListFilterableFields": {
      "accountId": "Account",
      "jobId": "Job",
      "programId": "Program",
      "status": "Status",
      "taskId": "Task"
    },
    "IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListFilterableFields": {
      "jobId": "Job",
      "status": "Status"
    },
    "IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListFilterableFields": {
      "accountId": "Account",
      "jobId": "Job",
      "programId": "Program",
      "status": "Status",
      "taskId": "Task"
    }
  },
  "oneOf": {
    "IxcGenerateV1MonthlyStatementsJobEventType": {
      "allCreated": "All Created",
      "allFinished": "All Finished",
      "created": "Created",
      "errored": "Errored",
      "metricsUpdated": "Metrics Updated",
      "tasksCreated": "Tasks Created"
    },
    "IxcGenerateV1MonthlyStatementsTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished"
    },
    "IxcGenerateV1TradeConfirmationsJobEventType": {
      "allCreated": "All Created",
      "allFinished": "All Finished",
      "created": "Created",
      "errored": "Errored",
      "metricsUpdated": "Metrics Updated",
      "tasksCreated": "Tasks Created"
    },
    "IxcGenerateV1TradeConfirmationsTaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished"
    }
  },
  "sortEnum": {
    "IxcGenerateV1MonthlyStatementsJobQueryServiceMonthlyStatementsJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcGenerateV1MonthlyStatementsTaskQueryServiceMonthlyStatementsTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcGenerateV1TradeConfirmationsJobQueryServiceTradeConfirmationsJobListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcGenerateV1TradeConfirmationsTaskQueryServiceTradeConfirmationsTaskListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}